import ProductShape from '../../shapes/product';
import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import AgGridReact from '../common/ag-table';
import { classes } from './styles/table';
import ProductIDCellComponent from "../common/product-id-cell";
import { withPermissions } from '../../services/permissions';

class ApplicationsInstancesView extends React.Component {

  state = {

  };

  constructor(props) {
    super(props);

    this.state.options = {
      context: {
        componentParent: this
      },
      localeText: {
        noRowsToShow: props.t('instances.emptyMessage')
      },
      frameworkComponents: {
        ProductIDCellComponent
      },
      columnDefs: [
        {
          field: 'uuid',
          headerName: props.t('instances.uuidHeader'),
          singleClickEdit: true
        },
        {
          field: 'package',
          headerName: props.t('instances.packageHeader'),
          editable: true,
          singleClickEdit: true
        },
        {
          field: 'name',
          headerName: props.t('instances.nameHeader'),
          cellRenderer: 'ProductIDCellComponent',
          editable: true,
          singleClickEdit: true
        }
      ],
      enableFilter: true,
      enableSorting: true,
      onGridReady: this.onGridReady
    }
  }

  onGridReady = ({ api }, subApi) => {
    this.gridApi = api;
    this.subGridApi = subApi;
  };

  render() {
    const { t } = this.props;
    return (
      <React.Fragment>
        <div className={classes.header}>
          <div />
          <h3>{this.props.name || t('instances.header')}</h3>
          <div>

          </div>
        </div>
        <div
          className={`ag-theme-blue ${classes.table}`}
        >
          <AgGridReact
            name="application-instances"
            {...this.state.options}
            items={this.props.products}
          />
        </div>
      </React.Fragment>
    )
  }

}

ApplicationsInstancesView.propTypes = {
  products: PropTypes.arrayOf(ProductShape).isRequired
};

export default translate(['product'])(withPermissions(ApplicationsInstancesView));



// WEBPACK FOOTER //
// ./src/views/applications/instances.js